module.exports = __webpack_public_path__ + "static/img/fenxiang1.65346e9d.png";